module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/custom.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Weapons of Our Warfare")]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "copyright-page"
    }
  }, [_c('p', {
    staticClass: "crt1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ii",
      "title": "ii"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAPONS OF")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UR")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARFARE")]), _vm._v(" by Greg Locke")])]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Published by Charisma House, an imprint of Charisma Media")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("600 Rinehart Road, Lake Mary, Florida 32746")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Copyright © 2023 by Greg Locke. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Unless otherwise noted, all Scripture quotations are from the King James Version of the Bible.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Scripture quotations marked "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESV")]), _vm._v(" are from the Holy Bible, English Standard Version. Copyright © 2001 by Crossway Bibles, a division of Good News Publishers. Used by permission.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Scripture quotations marked "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIV")]), _vm._v(" are taken from the Holy Bible, New International Version®, NIV®. Copyright © 1973, 1978, 1984, 2011 by Biblica, Inc.® Used by permission of Zondervan. All rights reserved worldwide. "), _c('a', {
    attrs: {
      "href": "http://www.zondervan.com",
      "target": "_blank"
    }
  }, [_vm._v("www.zondervan.com")]), _vm._v(". The “NIV” and “New International Version” are trademarks registered in the United States Patent and Trademark Office by Biblica, Inc.®")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Scripture quotations marked "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NKJV")]), _vm._v(" are taken from the New King James Version®. Copyright © 1982 by Thomas Nelson. Used by permission. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Cover design by Locke Media.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Photography and original graphics by Locke Media and Wayne Caparas.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("While the author has made every effort to provide accurate internet addresses at the time of publication, neither the publisher nor the author assumes any responsibility for errors or for changes that occur after publication. Further, the publisher does not have any control over and does not assume any responsibility for author or third-party websites or their content.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("For more Spirit-led resources, visit "), _c('a', {
    attrs: {
      "href": "http://charismamedia.com",
      "target": "_blank"
    }
  }, [_vm._v("charismamedia.com")]), _vm._v(" and the author’s website at "), _c('a', {
    attrs: {
      "href": "http://LockeMedia.org",
      "target": "_blank"
    }
  }, [_vm._v("LockeMedia.org")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Cataloging-in-Publication Data is on file with the Library of Congress.")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("International Standard Book Number: 978-1-63641-343-3")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("E-book ISBN: 978-1-63641-344-0")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Most Charisma Media products are available at special quantity discounts for bulk purchase for sales promotions, premiums, fund-raising, and educational needs. For details, call us at (407) 333-0600 or visit our website at "), _c('a', {
    attrs: {
      "href": "http://www.charismamedia.com",
      "target": "_blank"
    }
  }, [_vm._v("www.charismamedia.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Charisma House gratefully acknowledges the partnership of Global Vision Press in the publication of this book.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2a70f58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyrightpage.vue
// module id = 60
// module chunks = 0